import { ReactMarkdown } from 'components/ReactMarkdown'
import { useTranslation } from 'services/i18n'
import { MessageReference } from 'types/Api'
import { cn } from 'utils/cn'

import { isAiGeneratedSummary } from '../utils'

import { ReferenceSummaryDecorator } from './ReferenceSummaryDecorator'

import type { FC } from 'react'

type Props = {
  reference: MessageReference
  messageId: string
}

export const ReferenceContent: FC<Props> = ({ reference, messageId }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel',
  })

  const { content } = reference
  const hasContent = !!content && content.trim().length > 0

  const isAiSummary = isAiGeneratedSummary(reference)
  const showDecorator = isAiSummary

  if (hasContent) {
    return (
      <div className={cn('reference-content space-y-4 text-sm lg:text-default-on-bg-karnovnote', {
        'rounded-md border border-black/20 py-3 px-4': showDecorator,
      })}
      >
        { showDecorator && <ReferenceSummaryDecorator /> }
        <ReactMarkdown content={content} messageId={messageId} isReference />
      </div>
    )
  }

  return (
    <div className="mt-2 text-default-on-bg-karnovnote">
      {t('no_content_disclaimer')}
    </div>
  )
}
